module.exports = "pegasus/assets/blocks/header-6-basic.png";